import React, { useEffect } from "react";
import Image from "next/legacy/image";
import intervalToDuration from "date-fns/intervalToDuration";
import { Modal } from "components/modal/modal";
import { ModalSize } from "components/modal/modal.types";
import AlarmClock from "public/assets/alarm-clock.svg";
import {
  ModalBody,
  Heading,
  Description,
  RemainingTimeContainer,
  RemainingTimeWrapper,
  CloseCTA,
  Timer,
  TimerHighlight
} from "./class-not-started-yet-modal.styles";
import { ClassSession } from "services/api/sessions/sessionService.types";
import { getTimeStampFromDateString } from "components/kelas-live/utils";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";

interface Props {
  onClose: () => void;
  classSession: ClassSession;
  currentTimeStamp: string;
}

export const ClassNotStartedYetModal: React.FC<Props> = ({
  onClose,
  classSession,
  currentTimeStamp
}) => {
  const classSessionUpcomingTime = intervalToDuration({
    start: getTimeStampFromDateString(currentTimeStamp),
    end: getTimeStampFromDateString(classSession.startDate)
  });

  useEffect(() => {
    trackEvent({
      eventName: kelasLiveEvents.classYetToStartBottomSheetViewed,
      payload: {}
    });
  }, []);

  return (
    <Modal isOpen onClose={onClose} size={ModalSize.Narrow}>
      <ModalBody>
        <Heading>Kelasnya belum dimulai 🙏</Heading>
        <Description>Baru bisa masuk 5 menit sebelum kelas mulai</Description>
        <RemainingTimeContainer>
          <Image src={AlarmClock} alt="Remaining time" height={32} width={32} />
          <RemainingTimeWrapper>
            <div>Mulai dalam</div>
            <Timer>
              <TimerHighlight>
                {classSessionUpcomingTime.days} hari
              </TimerHighlight>
              <div>:</div>
              <TimerHighlight>
                {classSessionUpcomingTime.hours} jam
              </TimerHighlight>
              <div>:</div>
              <TimerHighlight>
                {classSessionUpcomingTime.minutes} menit
              </TimerHighlight>
            </Timer>
          </RemainingTimeWrapper>
        </RemainingTimeContainer>
        <CloseCTA variant="primary" onClick={onClose}>
          Oke, mengerti
        </CloseCTA>
      </ModalBody>
    </Modal>
  );
};
